<template>
  <div class="relay-picker">
    <template v-if="value">
      <input type="hidden" :name="name" :value="value.id" />

      <span class="relay-picker__relay-name">{{ relayName }}</span>
      <span class="relay-picker__relay-address">{{ relayAddress }}</span>
    </template>

    <button type="button" class="relay-picker__button" @click="showModal">
      {{ buttonLabel }}
    </button>

    <RelayModal
      :current-relay="value"
      :address="relayAddress"
      @relayConfirmed="relayConfirmed"
    />
  </div>
</template>

<script>
import Relay from '../../mixins/Relay';
import RelayModal from './RelayModal.vue';

export default {
  name: 'RelayPicker',
  components: { RelayModal },
  mixins: [Relay],
  props: {
    name: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    relay: {
      type: Object,
      default: () => ({}),
    },
    preventFirstModalDisplayOnMount: Boolean,
  },
  data() {
    return {
      value: this.relay || window.relayConfirmed,
    };
  },
  computed: {
    /**
     * @returns {string}
     */
    relayName() {
      return this.value.name;
    },
    /**
     * @returns {string|null}
     */
    relayAddress() {
      return this.value && this.value.address
        ? `${this.value.address}, ${this.value.zipcode} ${this.value.city}`
        : this.address;
    },
    /**
     * @returns {string}
     */
    buttonLabel() {
      return this.value ? 'Modifier' : 'Choisir mon point relais';
    },
  },
  mounted() {
    if (!this.value && this.shouldDisplayModal()) {
      this.showModal();
    }
  },
  methods: {
    showModal() {
      window.modalStateObservable.isRelayModalActive = true;
    },
    /**
     * @param {string} id
     * @param {string} name
     * @param {string} address1
     * @param {Array|string} address2
     * @param {Array|string} address3
     * @param {string} city
     * @param {string} zipcode
     */
    relayConfirmed({
      pudo_id: id,
      name,
      address1,
      address2,
      address3,
      city,
      zipcode,
    }) {
      this.value = {
        id,
        name,
        address: this.addressToString({ address1, address2, address3 }),
        zipcode,
        city,
      };
      window.relayConfirmed = this.value;
    },
    /**
     * @returns {boolean}
     */
    shouldDisplayModal() {
      if (
        this.preventFirstModalDisplayOnMount &&
        !window.firstModalDisplayPrevented
      ) {
        window.firstModalDisplayPrevented = true;
        return false;
      }

      return true;
    },
  },
};
</script>
